import { useState } from "react";
import { catalog } from "@/mocks/catalog";
import type { CatalogItem } from "@/pages/home/types";
import SectionHeading from "@/pages/home/components/SectionHeading";
import TitleCard from "@/pages/home/components/TitleCard";

const allSeries = (catalog as CatalogItem[]).filter((it) => it.featuredSeries);
const tabs = ["全部", "更新中", "已完结"];

export default function SeriesSection() {
  const [tab, setTab] = useState("全部");

  const list = allSeries.filter((it) => {
    if (tab === "全部") return true;
    if (tab === "已完结") return it.episodes.includes("已完结");
    return it.episodes.includes("更新至");
  });

  return (
    <section id="series" className="scroll-mt-20 bg-background-50">
      <div className="mx-auto w-full max-w-6xl px-4 py-16 md:px-6 md:py-20">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <SectionHeading
            eyebrow="热播剧榜"
            title="正在被讨论的热播剧，按跟播状态挑"
            desc="这里收录近期热度较高、讨论度稳定的剧集。想跟播就选「更新中」，想一口气看完就切到「已完结」，避免追到一半才发现需要等更。"
          />
          <div className="flex shrink-0 gap-1 rounded-full border border-background-200/70 bg-background-100 p-1">
            {tabs.map((t) => (
              <button
                key={t}
                type="button"
                onClick={() => setTab(t)}
                aria-pressed={tab === t}
                className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors cursor-pointer ${
                  tab === t
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-600 hover:text-primary-600"
                }`}
              >
                {t}
              </button>
            ))}
          </div>
        </div>

        {list.length > 0 ? (
          <div className="grid grid-cols-2 gap-3 md:gap-5 sm:grid-cols-3 lg:grid-cols-4">
            {list.map((item) => (
              <TitleCard key={item.id} item={item} />
            ))}
          </div>
        ) : (
          <div className="rounded-lg border border-dashed border-background-300 bg-background-100/60 px-6 py-12 text-center">
            <i className="ri-emotion-line text-3xl text-foreground-400"></i>
            <p className="mt-3 text-sm text-foreground-600">该状态下暂时没有剧集，换个筛选试试。</p>
          </div>
        )}

        <p className="mt-6 text-xs leading-relaxed text-foreground-500">
          榜单仅反映近期讨论热度与整理顺序，不构成对作品的评分结论；评分用于横向比较同类型作品的受认可程度。
        </p>
      </div>
    </section>
  );
}